"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_DETAILS = void 0;
exports.ERROR_DETAILS = {
    UnsupportedNetwork: "Network is not supported",
    OnboardingNotInitiated: "Onboarding is not initiated",
    LoginFailed: "Login attempt failed",
    NotLoggedIn: "The user is not logged in",
    ServerError: "Unable to process your request",
};
